import { Auth } from "./auth.js";

﻿const ToolNav = {
  _fxRates: {},
  _fxLoaded: false,
  _links: [
    { name: "文件转换", icon: "📁", url: "https://convertio.co/zh/", color: "#3b82f6" },
    { name: "国际物流追踪", icon: "📦", url: "https://www.17track.net/zh-cn", color: "#f97316" },
    { name: "国内快递追踪", icon: "🚚", url: "https://www.kuaidi100.com/", color: "#ef4444" },
    { name: "条码生成", icon: "🏷️", url: "https://barcode.tec-it.com/zh", color: "#8b5cf6" },
    { name: "HS编码查询", icon: "🔍", url: "https://www.hsbianma.com/", color: "#10b981" }
  ],

  init: function() {
    var self = this;
    self.renderLinks();
    self.fetchRates().then(function() {
      self.convertFX();
    });
    self.convertLength();
    self.convertWeight();
  },

  switchTab: function(tab) {
    ["convert", "links", "downloads"].forEach(function(n) {
      var el = document.getElementById("tool-tab-" + n);
      if (el) el.classList.toggle("active", n === tab);
    });
    document.querySelectorAll(".tool-tab-btn").forEach(function(b) {
      b.classList.toggle("active", b.getAttribute("data-tab") === tab);
    });
    if (tab === "downloads") this.renderDownloads();
  },

  // ===== 工具下载（列表来自服务器 downloads 目录，换文件即可更新） =====
  _downloadsLoaded: false,
  renderDownloads: function(force) {
    var grid = document.getElementById("tool-download-grid");
    if (!grid) return;
    if (this._downloadsLoaded && !force) return;
    var self = this;
    grid.innerHTML = '<div style="grid-column:1/-1;padding:24px;color:var(--text-muted);">加载中…</div>';
    Auth.apiFetch("/api/tools").then(function(data) {
      self._downloadsLoaded = true;
      var files = (data && data.files) || [];
      if (!files.length) {
        grid.innerHTML = '<div style="grid-column:1/-1;padding:24px;color:var(--text-muted);">暂无工具</div>';
        return;
      }
      var groups = [];
      files.forEach(function(f) {
        var g = groups.filter(function(x) { return x.name === f.group; })[0];
        if (!g) { g = { name: f.group, files: [] }; groups.push(g); }
        g.files.push(f);
      });
      var html = '<div style="grid-column:1/-1;display:flex;justify-content:space-between;align-items:center;gap:12px;flex-wrap:wrap;background:#f8fafc;border:1px solid #e2e8f0;border-radius:10px;padding:10px 14px;">' +
        '<span style="color:#64748b;font-size:0.8rem;line-height:1.6;">浏览器插件：下载解压后，打开 <b>chrome://extensions</b> → 右上角开启「开发者模式」→「加载已解压的扩展程序」→ 选解压出来的文件夹。<br>桌面工具：下载后直接双击运行（首次可能需在 Windows 里允许运行）。</span>' +
        '<button onclick="ToolNav.renderDownloads(true)" style="flex-shrink:0;background:#fff;color:#334155;border:1px solid #cbd5e1;border-radius:8px;padding:6px 12px;cursor:pointer;font-size:0.78rem;">刷新列表</button>' +
      '</div>';
      groups.forEach(function(g) {
        html += '<div style="grid-column:1/-1;margin-top:16px;font-weight:700;color:#0f172a;font-size:0.9rem;border-left:3px solid #0d9488;padding-left:8px;">' + self._esc(g.name) + '</div>';
        g.files.forEach(function(f) {
          html += '<div style="border:1px solid #e2e8f0;border-radius:10px;padding:14px 16px;display:flex;gap:12px;align-items:flex-start;background:#fff;">' +
            '<div style="font-size:1.5rem;line-height:1.2;">' + (f.icon || "\ud83d\udce6") + '</div>' +
            '<div style="flex:1;min-width:0;">' +
              '<div style="font-weight:700;color:#0f172a;">' + self._esc(f.name) + '</div>' +
              (f.desc ? '<div style="color:#64748b;font-size:0.78rem;margin-top:4px;line-height:1.7;">' + self._esc(f.desc) + '</div>' : '') +
              '<div style="color:#94a3b8;font-size:0.72rem;margin-top:6px;">' + self._esc(f.file) + ' · ' + self._fmtSize(f.size) + ' · 更新于 ' + self._esc(self._fmtDate(f.updatedAt)) + '</div>' +
            '</div>' +
            '<a href="' + f.url + '" download style="flex-shrink:0;background:#0d9488;color:#fff;text-decoration:none;padding:8px 16px;border-radius:8px;font-size:0.82rem;font-weight:700;">下载</a>' +
          '</div>';
        });
      });
      grid.innerHTML = html;
    }).catch(function(e) {
      self._downloadsLoaded = false;
      grid.innerHTML = '<div style="grid-column:1/-1;padding:24px;color:#b91c1c;">加载失败：' + self._esc(e && e.message) + '</div>';
    });
  },
  _esc: function(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function(c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  },
  _fmtSize: function(n) {
    n = Number(n) || 0;
    if (n < 1024) return n + " B";
    if (n < 1024 * 1024) return (n / 1024).toFixed(1) + " KB";
    return (n / 1024 / 1024).toFixed(1) + " MB";
  },
  _fmtDate: function(iso) {
    var s = String(iso || "");
    return s ? s.slice(0, 10) : "-";
  },

  // ===== 网址导航 =====
  renderLinks: function() {
    var grid = document.getElementById("tool-link-grid");
    if (!grid) return;
    var html = "";
    var self = this;
    this._links.forEach(function(link) {
      html += '<div class="tool-link-card" onclick="window.open(\'' + link.url + '\', \'_blank\')" style="border-top: 3px solid ' + link.color + ';">' +
        '<div class="tool-link-icon">' + link.icon + '</div>' +
        '<div class="tool-link-name">' + link.name + '</div>' +
      '</div>';
    });
    grid.innerHTML = html;
  },

  // ===== 汇率换算 =====
  fetchRates: function() {
    var self = this;
    return fetch("https://api.exchangerate-api.com/v4/latest/USD")
      .then(function(r) { return r.json(); })
      .then(function(data) {
        self._fxRates = data.rates || {};
        self._fxLoaded = true;
        var rateEl = document.getElementById("fx-rate");
        if (rateEl) {
          var cny = self._fxRates["CNY"];
          rateEl.textContent = cny ? "实时: 1 USD = " + cny.toFixed(4) + " CNY" : "";
        }
        return data;
      })
      .catch(function(e) {
        console.error("汇率获取失败:", e);
        self._fxLoaded = false;
        var rateEl = document.getElementById("fx-rate");
        if (rateEl) rateEl.textContent = "⚠ 汇率获取失败，请稍后再试";
      });
  },

  convertFX: function() {
    var amount = parseFloat(document.getElementById("fx-amount").value) || 0;
    var from = document.getElementById("fx-from").value;
    var to = document.getElementById("fx-to").value;
    var resultEl = document.getElementById("fx-result");

    if (!this._fxLoaded) {
      if (resultEl) resultEl.textContent = "汇率加载中...";
      return;
    }
    if (amount === 0) {
      if (resultEl) resultEl.textContent = "-";
      return;
    }

    var fromRate = from === "USD" ? 1 : (this._fxRates[from] || 1);
    var toRate = to === "USD" ? 1 : (this._fxRates[to] || 1);
    var usdAmount = amount / fromRate;
    var result = usdAmount * toRate;

    if (resultEl) resultEl.textContent = "= " + result.toFixed(2) + " " + to;
  },

  // ===== 长度换算 =====
  _lenToMeter: { mm: 0.001, cm: 0.01, m: 1, km: 1000, inch: 0.0254, foot: 0.3048, yard: 0.9144, mile: 1609.344 },
  _meterToLen: { mm: 1000, cm: 100, m: 1, km: 0.001, inch: 39.3701, foot: 3.28084, yard: 1.09361, mile: 0.000621371 },

  convertLength: function() {
    var val = parseFloat(document.getElementById("len-val").value) || 0;
    var from = document.getElementById("len-from").value;
    var to = document.getElementById("len-to").value;
    var el = document.getElementById("len-result");
    if (val === 0) { if (el) el.textContent = "-"; return; }
    var meters = val * this._lenToMeter[from];
    var result = meters * this._meterToLen[to];
    if (el) el.textContent = "= " + parseFloat(result.toFixed(6)) + " " + to;
  },

  // ===== 重量换算 =====
  _wtToGram: { g: 1, kg: 1000, oz: 28.3495, lb: 453.592 },
  _gramToWt: { g: 1, kg: 0.001, oz: 0.035274, lb: 0.00220462 },

  convertWeight: function() {
    var val = parseFloat(document.getElementById("wt-val").value) || 0;
    var from = document.getElementById("wt-from").value;
    var to = document.getElementById("wt-to").value;
    var el = document.getElementById("wt-result");
    if (val === 0) { if (el) el.textContent = "-"; return; }
    var grams = val * this._wtToGram[from];
    var result = grams * this._gramToWt[to];
    if (el) el.textContent = "= " + parseFloat(result.toFixed(4)) + " " + to;
  },

  // ===== 美元金额大小写 =====
  _ones: ["", "ONE", "TWO", "THREE", "FOUR", "FIVE", "SIX", "SEVEN", "EIGHT", "NINE"],
  _teens: ["TEN", "ELEVEN", "TWELVE", "THIRTEEN", "FOURTEEN", "FIFTEEN", "SIXTEEN", "SEVENTEEN", "EIGHTEEN", "NINETEEN"],
  _tens: ["", "", "TWENTY", "THIRTY", "FORTY", "FIFTY", "SIXTY", "SEVENTY", "EIGHTY", "NINETY"],

  _convertHundreds: function(n) {
    var s = "";
    if (n >= 100) { s += this._ones[Math.floor(n / 100)] + " HUNDRED "; n %= 100; }
    if (n >= 20) { s += this._tens[Math.floor(n / 10)] + " "; n %= 10; }
    else if (n >= 10) { s += this._teens[n - 10] + " "; n = 0; }
    if (n > 0) s += this._ones[n] + " ";
    return s;
  },

  convertUSDWords: function() {
    var raw = document.getElementById("usd-amount").value.trim();
    var el = document.getElementById("usd-result");
    if (!raw) { el.textContent = "-"; return; }
    var num = parseFloat(raw);
    if (isNaN(num) || num < 0) { el.textContent = "请输入有效金额"; return; }

    var dollars = Math.floor(num);
    var cents = Math.round((num - dollars) * 100);
    var result = "";

    if (dollars === 0) {
      result = "ZERO";
    } else {
      if (dollars >= 1000000) {
        result += this._convertHundreds(Math.floor(dollars / 1000000)) + "MILLION ";
        dollars %= 1000000;
      }
      if (dollars >= 1000) {
        result += this._convertHundreds(Math.floor(dollars / 1000)) + "THOUSAND ";
        dollars %= 1000;
      }
      result += this._convertHundreds(dollars);
    }

    if (cents > 0) {
      var centWords = this._convertHundreds(cents).trim() || "ZERO";
      el.textContent = "SAY USD " + result.trim() + " AND " + centWords + " CENTS ONLY";
    } else {
      el.textContent = "SAY USD " + result.trim() + " ONLY";
    }
  },

  // ===== 人民币金额大小写 =====
  _cnyDigits: ["零", "壹", "贰", "叁", "肆", "伍", "陆", "柒", "捌", "玖"],
  _cnyUnits: ["", "拾", "佰", "仟"],
  _cnyBigUnits: ["", "万", "亿"],

  _cnySection: function(n) {
    var s = "";
    var hasVal = false;
    for (var i = 0; i < 4; i++) {
      var d = n % 10;
      if (d > 0) {
        s = this._cnyDigits[d] + this._cnyUnits[i] + s;
        hasVal = true;
      } else {
        if (hasVal && s.charAt(0) !== "零") {
          s = "零" + s;
        }
      }
      n = Math.floor(n / 10);
    }
    if (s.length > 0 && s.charAt(s.length - 1) === "零") {
      s = s.substring(0, s.length - 1);
    }
    return s;
  },

  convertCNYWords: function() {
    var raw = document.getElementById("cny-amount").value.trim();
    var el = document.getElementById("cny-result");
    if (!raw) { el.textContent = "-"; return; }
    var num = parseFloat(raw);
    if (isNaN(num) || num < 0) { el.textContent = "请输入有效金额"; return; }

    var yuan = Math.floor(num);
    var jiao = Math.round((num - yuan) * 10);
    var fen = Math.round((num - yuan - jiao / 10) * 100);

    if (yuan === 0 && jiao === 0 && fen === 0) {
      el.textContent = "零元整";
      return;
    }

    var result = "";

    if (yuan === 0) {
      result = "零";
    } else {
      var sections = [];
      var n = yuan;
      var si = 0;
      while (n > 0) {
        var section = n % 10000;
        var secStr = this._cnySection(section);
        if (secStr) {
          sections.unshift(secStr + (si > 0 ? this._cnyBigUnits[si] : ""));
        }
        n = Math.floor(n / 10000);
        si++;
      }
      result = sections.join("");
      // clean up consecutive zeros
      result = result.replace(/零+/g, "零");
      if (result.endsWith("零")) result = result.substring(0, result.length - 1);
      if (result === "") result = "零";
    }

    result += "元";

    if (jiao > 0) {
      result += this._cnyDigits[jiao] + "角";
    }
    if (fen > 0) {
      result += this._cnyDigits[fen] + "分";
    }
    if (jiao === 0 && fen === 0) {
      result += "整";
    }

    el.textContent = "人民币" + result;
  }
};
window.ToolNav = ToolNav;
export { ToolNav };